import useConfigStore from '@/store/config.store';
import { GuidettiWorld } from '@/guidetti/GuidettiWorld';
import { storeToRefs } from 'pinia';

function useAnimationControl() {
    const { isAnimated, isPollOpen } = storeToRefs(useConfigStore());

    function startAnimation() {
        isAnimated.value = true;
        GuidettiWorld.animateCamera(isAnimated.value);
    }

    function stopAnimation() {
        isAnimated.value = false;
        GuidettiWorld.animateCamera(isAnimated.value);
    }

    function openPoll() {
        isPollOpen.value = true;
        GuidettiWorld.openPollAnimation();
    }

    function closePoll() {
        isPollOpen.value = false;
        GuidettiWorld.closePollAnimation();
    }

    function toggleAnimation() {
        if (isAnimated.value) {
            stopAnimation();
        } else {
            startAnimation();
        }
    }

    return {
        toggleAnimation,
        startAnimation,
        stopAnimation,
        isAnimated,
        isPollOpen,
        openPoll,
        closePoll,
    };
}

export default useAnimationControl;
